{
  "background": {
    "background-default": "rgb(5, 7, 9)",
    "background-subtle": "rgb(14, 17, 19)"
  },
  "surface": {
    "surface-default": "rgb(14, 17, 19)",
    "surface-raised": "rgb(34, 39, 43)",
    "surface-sunken": "rgb(5, 7, 9)"
  },
  "text": {
    "text-default": "rgb(245, 245, 245)",
    "text-muted": "rgb(205, 211, 214)",
    "text-subtle": "rgb(136, 143, 146)",
    "text-inverse": "rgb(5, 7, 9)",
    "text-link": "rgb(140, 224, 255)"
  },
  "border": {
    "border-default": "rgb(53, 59, 63)",
    "border-subtle": "rgb(34, 39, 43)",
    "border-strong": "rgb(136, 143, 146)"
  },
  "action": {
    "action-default": "rgb(38, 174, 255)",
    "action-hover": "rgb(140, 224, 255)",
    "action-subtle": "rgb(0, 16, 55)"
  },
  "success": {
    "success-surface": "rgb(0, 22, 0)",
    "success-text": "rgb(143, 199, 138)",
    "success-border": "rgb(0, 90, 2)",
    "success-solid": "rgb(57, 153, 54)"
  },
  "warning": {
    "warning-surface": "rgb(39, 4, 0)",
    "warning-text": "rgb(238, 168, 138)",
    "warning-border": "rgb(136, 47, 3)",
    "warning-solid": "rgb(211, 103, 52)"
  },
  "danger": {
    "danger-surface": "rgb(35, 0, 2)",
    "danger-text": "rgb(234, 146, 148)",
    "danger-border": "rgb(124, 6, 31)",
    "danger-solid": "rgb(198, 63, 78)"
  },
  "info": {
    "info-surface": "rgb(2, 7, 28)",
    "info-text": "rgb(128, 152, 194)",
    "info-border": "rgb(25, 51, 102)",
    "info-solid": "rgb(66, 100, 164)"
  }
}
